// 個別のjsを指定しなかった時に読み込まれるjs
import "js/base"